import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.div`
  width: 100%;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.silver.primary};
  margin-bottom: 56px;
`;
